export default __webpack_public_path__ + "static/media/nammi_desktop.efc56672.jpg";